// Escala única de condición (espejo de backend/game_config.py CONDITION_SCALE).
// La leen P3, P5, subastas, cola, admin, catálogo y el detalle público.
export const CONDITIONS = [
  { value: "NM", name: "Near Mint", desc: "casi perfecta, mínimo desgaste en bordes" },
  { value: "LP", name: "Lightly Played", desc: "juego ligero: rayones leves, esquinas apenas gastadas" },
  { value: "MP", name: "Moderately Played", desc: "marcas visibles en bordes y superficie" },
  { value: "HP", name: "Heavily Played", desc: "desgaste fuerte: pliegues o marcas notorias" },
  { value: "DMG", name: "Damaged", desc: "dañada: roturas, dobleces o daño por agua" },
];
export const MIXED = { value: "MIXED", name: "Mixto", desc: "solo lotes: estados variados, ver fotos" };

const ALL = [...CONDITIONS, MIXED];
// Lectura de códigos viejos (antes de migrar): M→NM, EX→LP, GD→MP, PL→HP.
const LEGACY = { M: "NM", EX: "LP", GD: "MP", PL: "HP" };
const find = (v) => ALL.find((c) => c.value === (LEGACY[v] || v));
export const condShort = (v) => { const c = find(v); return c ? `${c.value} · ${c.name}` : (v || ""); };
export const isLotProduct = (p) => /lot|bulk|deck|collection|bundle/.test(String(p?.product_type || ""));

export const condLabel = (v) => { const c = find(v); return c ? `${c.value} · ${c.name} — ${c.desc}` : (v || ""); };
export const condName = (v) => { const c = find(v); return c ? `${c.name} (${c.value})` : (v || ""); };
export const condDesc = (v) => find(v)?.desc || "";
export const conditionOptions = (withMixed = false) => (withMixed ? ALL : CONDITIONS).map((c) => ({ value: c.value, label: condLabel(c.value) }));
